var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatusSolutionsNetworkLogoSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.53,
    height: 29.999,
    viewBox: "0 0 37.53 29.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "StatusSolutionsNetwork-Logo-mark-01",
    transform: "translate(-46.143 -77.28)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_140",
    "data-name": "Path 140",
    d: "M84.777,84.448l-.03-7.168a30.025,30.025,0,0,0-13.839,4.547,27.286,27.286,0,0,0-9.818,9.83c.636.273,3.753,1.6,7.033,2.753.15-.781.244-1.381.257-1.469a17.828,17.828,0,0,1,.79-4.023c.7-2.114,1.683-3.8,4.73-3.864,2.783-.057,4.078-.024,5.67,5.634.764,2.722.8,4.048,1.977,4.165s1.36-.63,1.527-2.316A73.535,73.535,0,0,1,84.483,85.3",
    transform: "translate(-13.125)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_141",
    "data-name": "Path 141",
    d: "M144,185.248l.029,7.17a29.146,29.146,0,0,0,14.157-4.737,28.263,28.263,0,0,0,9.6-9.63h-.02a.155.155,0,0,0-.013.024c-.469-.2-3.842-1.648-7.335-2.863-.182.952-.28,1.7-.308,1.829-.69,3.074-.88,4.453-1.618,5.387-1,1.265-2.309,1.759-4.542,1.69a3.914,3.914,0,0,1-3.736-2.454,19.227,19.227,0,0,1-1.169-3.246c-.862-2.857-.488-4.159-2-4.178-1.607-.02-1.524,2.221-1.707,4.076a56.729,56.729,0,0,1-1.09,6.132",
    transform: "translate(-85.928 -85.139)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_142",
    "data-name": "Path 142",
    d: "M51.8,254.146l8.168-6.437.1-.51L49.19,250.3a7.809,7.809,0,0,0,2.61,3.844",
    transform: "translate(-2.675 -149.206)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143",
    "data-name": "Path 143",
    d: "M90.325,269.718l1.782-7.448-6.217,6.274a12.2,12.2,0,0,0,4.441,1.174",
    transform: "translate(-34.902 -162.439)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_144",
    "data-name": "Path 144",
    d: "M271.472,151.221l-10.562-2.36.032-.412,11.316-1.829a11.868,11.868,0,0,1-.786,4.6",
    transform: "translate(-188.586 -60.887)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_145",
    "data-name": "Path 145",
    d: "M270.026,96.46l-8.168,6.437-.1.51,10.879-3.1a7.815,7.815,0,0,0-2.61-3.845",
    transform: "translate(-189.332 -16.842)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_146",
    "data-name": "Path 146",
    d: "M265.042,77.28l-1.782,7.447,6.223-6.274a12.19,12.19,0,0,0-4.441-1.173",
    transform: "translate(-190.649)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_147",
    "data-name": "Path 147",
    d: "M46.93,216.28l10.563,2.358-.03.412-11.319,1.836a11.874,11.874,0,0,1,.786-4.605",
    transform: "translate(0 -122.055)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusSolutionsNetworkLogoSmall);
export default __webpack_public_path__ + "static/media/StatusSolutionsNetworkLogoSmall.203af91901775bf5755b90a1d07dfb4f.svg";
export { ForwardRef as ReactComponent };